import { createElement, FC, ReactNode, Fragment } from 'react';
import { InPageFlowLayout } from 'legos/in-page-flow-layout';
import { ContentBlock } from 'legos/content-block';
import { Disclosure, Title } from 'legos/typography';
import { Anchor } from 'packages/react-nano-router';
import {
  MainContainer,
  MobileContainer,
  DesktopTitleStyles,
  DesktopContainer,
  DisclosureStyle,
  MainContent
} from './risingtide-main-page-template.ccm.css';

interface Props {
  title: ReactNode;
  disclaimers?: ReactNode;
  backAnchor?: Anchor;
}

const DesktopTitleStyle = DesktopTitleStyles.as(Title);
const DisclosureText = DisclosureStyle.as(Disclosure);

export const RisingTideMainPageTemplate: FC<Props> = ({
  title,
  children,
  backAnchor,
  disclaimers,
  ...props
}) => {
  return (
    <MainContainer.div {...(props as any)}>
      <MainContent.div>
        {backAnchor ? (
          <InPageFlowLayout title={title} backAnchor={backAnchor}>
            {children}
          </InPageFlowLayout>
        ) : (
          <Fragment>
            <MobileContainer.div>
              <InPageFlowLayout title={title} backAnchor={backAnchor}>
                {children}
              </InPageFlowLayout>
            </MobileContainer.div>
            <DesktopContainer.div>
              <ContentBlock fullWidth bottomSpace="none">
                <DesktopTitleStyle>{title}</DesktopTitleStyle>
                {children}
              </ContentBlock>
            </DesktopContainer.div>
          </Fragment>
        )}
      </MainContent.div>
      {disclaimers && <DisclosureText>{disclaimers}</DisclosureText>}
    </MainContainer.div>
  );
};
